module.exports = __webpack_public_path__ + "media/images/tl/banner/id-2-dark-5f14aa36324d0e003242e5342d54732f.jpg";